import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Uvodni.png'


const _withScopeId = n => (_pushScopeId("data-v-056732ad"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  draggable: "false"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Otestujte si svou orientaci na „životní” cestě plastů", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, " Teď, když o plastech víte hromadu novinek, si své znalosti můžete ověřit v malém kvízu. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

import { ref } from 'vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'WelcomeScreen',
  setup(__props) {

const store = useStore()

const isActive = ref(true)

const start = () => {
  store.commit('start')
  isActive.value = false
}

return (_ctx: any,_cache: any) => {
  return (isActive.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", { class: "horizontal" }, [
          _hoisted_2,
          _createElementVNode("div", { class: "info" }, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("button", {
              class: "button solidButton",
              onClick: start
            }, "Spustit kvíz")
          ]),
          _hoisted_5
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})